/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { FormikProps } from 'formik';
import {
  BlogInput,
  BrandMissionInput,
  EmailInput,
  PersonaBlogInput,
  PersonaEmailInput,
  PersonaNewsletterInput,
  PersonaSocialInput,
  SocialInput,
  TikTokCaptionInput,
  YoutubeVideoScriptInput,
  ShortVideoScriptInput,
  LinkedInCompanyBioInput,
  ValuePropInput,
  JobDescriptionInput,
} from '../../../../../types/FormTypes';
import { BasicFieldArray } from '../../../../shared/inputs/BasicFieldArray';
import { PersonaSocialForm } from '../social/PersonaSocialForm';

type KeywordInputsProps<T> = {
  formikProps: FormikProps<T>;
  disabled: boolean;
};

export function KeywordInputs<
  T extends
    | BlogInput
    | PersonaBlogInput
    | SocialInput
    | PersonaSocialInput
    | EmailInput
    | PersonaEmailInput
    | PersonaNewsletterInput
    | TikTokCaptionInput
    | BrandMissionInput
    | YoutubeVideoScriptInput
    | ShortVideoScriptInput
    | LinkedInCompanyBioInput
    | ValuePropInput
    | JobDescriptionInput
>({ formikProps, disabled }: KeywordInputsProps<T>) {
  return (
    <BasicFieldArray
      id="topics"
      label={
        <div>
          <h2>What are the keywords you want to include?</h2>
          <p>
            Describe topics or keywords that you want this copy to include. Ex.
            family hiking trips and Tupac.
          </p>
        </div>
      }
      placeholder="Specific keywords (optional)"
      value={formikProps.values.topics}
      disabled={disabled}
      errors={formikProps.errors.topics as string}
      touched={formikProps.touched.topics ? true : false}
      onBlur={formikProps.handleBlur}
    />
  );
}
